import React from "react"
import {DAY_TIME_HOUR_LIST} from "../../constants/datetime"

import {v4 as uuid4} from 'uuid'

const DayTimeSelect = ({value="", onChange=()=>{}, keyId=uuid4()}) => {
    return (
        <select 
            className="border-width-1px border-style-outset background-color-white border-radius-4px"
            value={value}
            onChange={onChange}
        >
            {
                DAY_TIME_HOUR_LIST.map(({id, text}) => <option key={`${id}${keyId}`}value={id}>{text}</option>)
            }
        </select>
    )
}

export default DayTimeSelect